import { render, staticRenderFns } from "./AccidentStatusModal.vue?vue&type=template&id=32f94716"
import script from "./AccidentStatusModal.vue?vue&type=script&lang=js"
export * from "./AccidentStatusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports